import fetchHandler from "../../utils/fetchHandler";
import {MY_FOOD} from "../types/actions";

export const getMyFoodList = (queryString) => {
    const fetchOptions = {
        url: `/api/food/myfoodlist/?${queryString}`,
		method: "GET",
        actionType: MY_FOOD.GET_MY_FOOD_LIST
    };
    return fetchHandler(fetchOptions);
};

export const saveMyFoodItem = (values, successHandler) => {
    const fetchOptions = {
        url: `/api/food/${values.id}`,
        method: "PUT",
        actionType: MY_FOOD.SAVE_MY_FOOD_ITEM,
        body: JSON.stringify(values)
    };

    return fetchHandler(fetchOptions, successHandler);
};

export const addMyFoodItem = (values, successHandler) => {
    const fetchOptions = {
        url: `/api/food/myfood/`,
        method: "POST",
        actionType: MY_FOOD.SAVE_MY_FOOD_ITEM,
        body: JSON.stringify(values)
    };

    return fetchHandler(fetchOptions, successHandler);
};

export const deleteMyFoodItem = (id, successHandler) => {
    const fetchOptions = {
        url: `/api/food/${id}`,
        method: "DELETE",
        actionType: MY_FOOD.DELETE_MY_FOOD_ITEM,
    };

    return fetchHandler(fetchOptions, successHandler);
};
